import React from "react";
// import './SubReference.scss';

function SubReference(props) {
    console.log("PROPS: ", props)
    console.log("PROPS.TEST: ", props.test)
    
    return(
        <div className={`SubReference`}>
           <h3>{props.top}</h3>
        </div>
    )
}

export default SubReference